import { createBrowserRouter, Navigate, Outlet, useLocation } from 'react-router-dom';
import Landing from './pages/Landing';
import Pricing from './pages/Pricing';
import DataResidency from './pages/DataResidency';
import Onboarding from './pages/Onboarding';
import Session from './pages/Session';
import Paywall from './pages/Paywall';
import Report from './pages/Report';
import TryReading from './pages/TryReading';
import InfoPage from './pages/InfoPage';
import BusinessOverview from './pages/BusinessOverview';
import About from './pages/About';
import Lab from './pages/Lab';
import ThemeSwitcher from './components/ThemeSwitcher';
import LangSwitcher from './components/LangSwitcher';

/**
 * react-router-dom v7 — single browser router with a shared shell layout
 * that hosts the theme + lang switchers (top-right).
 */

function Shell() {
  const location = useLocation();
  const showThemeSwitcher =
    location.pathname.startsWith('/pricing') ||
    location.pathname.startsWith('/about') ||
    location.pathname.startsWith('/lab') ||
    location.pathname.startsWith('/data-residency') ||
    location.pathname.startsWith('/onboarding');
  const showLangSwitcher = !location.pathname.startsWith('/session/');

  return (
    <div className="min-h-screen bg-bg text-fg font-body antialiased">
      {(showThemeSwitcher || showLangSwitcher) && (
        <header className="fixed right-4 top-4 z-50 flex items-center gap-2">
          {showThemeSwitcher && <ThemeSwitcher />}
          {showLangSwitcher && <LangSwitcher />}
        </header>
      )}
      <Outlet />
    </div>
  );
}

export const router = createBrowserRouter([
  {
    element: <Shell />,
    children: [
      { path: '/', element: <Landing /> },
      { path: '/try/:version', element: <TryReading /> },
      { path: '/pricing', element: <Pricing /> },
      { path: '/about', element: <About /> },
      { path: '/lab', element: <Lab /> },
      { path: '/data-residency', element: <DataResidency /> },
      { path: '/about/compliance', element: <InfoPage page="compliance" /> },
      { path: '/about/technical', element: <InfoPage page="technical" /> },
      { path: '/business', element: <BusinessOverview /> },
      { path: '/business/pricing', element: <InfoPage page="pricing" /> },
      { path: '/business/model', element: <InfoPage page="model" /> },
      { path: '/onboarding', element: <Onboarding /> },
      { path: '/session/:id', element: <Session /> },
      { path: '/session/:id/paywall', element: <Paywall /> },
      { path: '/session/:id/report', element: <Report /> },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);
